module.exports = __webpack_public_path__ + "img/pic_suppay_suppay_black@3x.b26810d7.png";